import { AppState } from '../../../interfaces';
import { connect } from 'react-redux';
import Checkout from './Checkout';
import {
  getFreeProducts,
  preCheckout,
  persistDetails,
  clearAddress,
  addToOrder,
  removeFromOrder,
  submitOrder,
  submitOrderPack,
} from '../../../actions/freeProducts';

const mapStateToProps = (state: AppState) => ({
  page: state.freeProductsReducer,
  user: state.authReducer,
  app: state.appReducer,
  listLocation: state.listLocationReducer,
  userData: state.userReducer,
});

const mapDispatchToProps = (dispatch) => ({
  clearAddress: () => dispatch(clearAddress()),
  preCheckout: (data) => dispatch(preCheckout(data)),
  submitOrder: (data, onSuccess, onFailed) =>
    dispatch(submitOrder(data, onSuccess, onFailed)),
  submitOrderPack: (data, locationId, onSuccess, onFailed) =>
    dispatch(submitOrderPack(data, locationId, onSuccess, onFailed)),
  persistDetails: (data) => dispatch(persistDetails(data)),
  getFreeProducts: (data) => dispatch(getFreeProducts(data)),
  addToOrder: (id) => dispatch(addToOrder(id)),
  removeFromOrder: (id) => dispatch(removeFromOrder(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
